import { Route, Routes } from "react-router-dom";

// import { Transfers } from "../../pages";

export const TransfersLayout = () => {
  return <Routes>{/* <Route path="/*" element={<Transfers />} /> */}</Routes>;
};
